module.exports = __webpack_public_path__ + "media/images/weather/100_day-cae24dc9a29c83ee55749faa4b152eca.png";